
  <div class="inicio">
    <p class="titulo">ALTA DE EQUIPO
      <mat-icon color="primary" matTooltip="Click para más información" (click)="botonInformacion()" >info</mat-icon>
      <!--<button mat-mini-fab style="background-color: #161aff;" matTooltip="Click para más información" (click)="botonInformacion()"> <span class="material-icons">info</span> </button>-->
    </p>
    <div class="requerido"> <mat-label>* Campos requeridos  </mat-label> </div>
    <form #insertForm="ngForm" [formGroup]="formInsertar" (ngSubmit)="agregarEquipo()">
      <div class="form-group">
      </div>

        <!--Datos de la categoria y tipo de dispositivo-->
        <div class="div">

            <!--Parte 1-->
            <div class="grid-containerB">

              <div class="celda">
                <mat-label class="label">Dispositivo<mat-label class="requerido">*</mat-label></mat-label>
                <mat-form-field appearance="outline" >
                    <mat-select placeholder="Selecciona el tipo de activo"  formControlName="activo"  (selectionChange)="selectActivo()" required>
                        <mat-option *ngFor="let activo of listaactivos" [value]=activo >{{ activo }} </mat-option>
                    </mat-select>
                    <mat-error *ngIf="this.formInsertar.get('activo')?.errors?.['required']">
                      El dispositivo es requerido
                    </mat-error>

                </mat-form-field>
            </div>

                <!--Tipo de dispositivo del activo seleccionado-->
                <div class="celda">
                    <mat-label class="label">Tipo<mat-label class="requerido">*</mat-label></mat-label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Selecciona el tipo de activo" formControlName="tipo" (opened)="selectTipoModelo()" required>
                            <mat-option *ngFor="let tipo of listaTipos" [value] = tipo.id> {{ tipo.name }} </mat-option>
                        </mat-select>
                        <mat-error *ngIf="this.formInsertar.get('tipo')?.errors?.['required']">
                          El tipo es requerido
                      </mat-error>
                    </mat-form-field>
                </div>
                <div>
                  <button  mat-mini-fab type="button" style="background-color: #04da44cc;" class="btn btn-primary mx-auto d-block" *ngIf="mostrarBotonesTipoModelo()" (click)="agregarTipoModelo('TIPO')" > <mat-icon>add</mat-icon> </button>
                </div>

            </div>

            <!--Parte 2-->
            <div class="grid-containerB">


                <!--Nombre de inventario-->
                <div class="celda">
                    <mat-label class="label"> Nombre de inventario<mat-label class="requerido">*</mat-label></mat-label>
                    <mat-form-field class="example-form-field" appearance="outline">
                        <input matInput type="text" placeholder="Ingresa el nombre"  formControlName="nombreInventario" (keydown.space)="$event.preventDefault();" required oninput="this.value = this.value.toUpperCase()"/>
                        <mat-error *ngIf="this.formInsertar.get('nombreInventario')?.errors?.['required']">
                          El nombre de inventario es requerido
                      </mat-error>
                    </mat-form-field>
                </div>
                 <!--Modelo del equipo-->
                <div class="celda">
                    <mat-label class="label"> Modelo<mat-label class="requerido">*</mat-label></mat-label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Selecciona el Modelo" formControlName="modelo"  (opened)="selectTipoModelo()" required>
                            <mat-option *ngFor="let modelo of listaModelo" [value]="modelo.id"> {{ modelo.name }} </mat-option>
                        </mat-select>
                        <mat-error *ngIf="this.formInsertar.get('modelo')?.errors?.['required']">
                          El modelo es requerido
                      </mat-error>
                    </mat-form-field>
                </div>
                <div>
                   <button  mat-mini-fab type="button" style="background-color: #04da44cc;" class="btn btn-primary mx-auto d-block" *ngIf="mostrarBotonesTipoModelo()" (click)="agregarTipoModelo('MODELO')" > <mat-icon>add</mat-icon> </button>
                </div>
              </div>
              <div class="grid-container2">
                 <!--Descargar codigo de barras-->
                 <div *ngIf="this.formInsertar.value.nombreInventario.length!=0">
                  <div id="codigoBarras">
                   <div style="text-align:center">
                     <ngx-barcode6
                       [bc-format]="'CODE128'"
                       [bc-value]="formInsertar.value.nombreInventario"
                       [bc-display-value]="true"
                       [bc-height] = "30"
                       [bc-width]="1"
                     >
                     </ngx-barcode6>
                   </div>
                  </div>
                  <button type="button" class="btn btn-primary mt-3 mb-5 mx-auto d-block" (click)="descargarCodigoBarras()">Descargar</button>
                 </div>



                <!--Numero de serie-->
                <div class="celda">
                    <mat-label class="label"> Número de serie<mat-label class="requerido">*</mat-label></mat-label>
                    <mat-form-field class="example-form-field" appearance="outline">
                        <input matInput type="text" placeholder="Ingresa el número de serie" formControlName="numeroSerie" required oninput="this.value = this.value.toUpperCase()"/>
                        <mat-error *ngIf="this.formInsertar.get('numeroSerie')?.errors?.['required']">
                          El número de serie es requerido
                      </mat-error>
                    </mat-form-field>
                </div>


                <!-- Responsable Técnico -->
                <div class="celda">
                    <mat-label class="label">Responsable técnico</mat-label>
                    <mat-form-field appearance="outline">
                    <mat-select placeholder="Ingresa el nombre del resp. técnico" formControlName="responsableTecnico" >
                        <mat-option *ngFor="let usuario of listaResTecnico" [value]="usuario.id"> {{usuario.realname}} {{usuario.firstname}} </mat-option>
                    </mat-select>
                    </mat-form-field>
                </div>

                <!--Sucursal donde se encuentra el equipo-->
                <div class="celda">
                    <mat-label class="label">Sucursal<mat-label class="requerido">*</mat-label></mat-label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Sucursal" formControlName="sucursal"  required>
                            <mat-option *ngFor="let sucursal of listaSucursal" [value]="sucursal.id"> {{ sucursal.name }} </mat-option>
                        </mat-select>
                        <mat-error *ngIf="this.formInsertar.get('sucursal')?.errors?.['required']">
                          La sucursal es requerida
                      </mat-error>
                    </mat-form-field>
                </div>

                <!-- Uuid -->
                <div class="celda" *ngIf="activoSeleccionado('COMPUTADORA')">
                    <mat-label class="label"> UUID (Número de identificación universal) </mat-label>
                    <mat-form-field class="example-form-field" appearance="outline">
                        <input matInput type="text" placeholder="Ejm. 550e8400-e29b-41d4-a716-446655440000" formControlName="uuid" (keydown.space)="$event.preventDefault();" pattern="^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$" oninput="this.value = this.value.toUpperCase()"/>
                    </mat-form-field>
                </div>

                <!--Fabricante o marca del sipositivo-->
                <div class="grid-containerC">
                  <div class="celda" >
                      <mat-label class="label"> Fabricante<mat-label class="requerido">*</mat-label></mat-label>
                      <mat-form-field appearance="outline">
                          <mat-select placeholder="Selecciona al fabricante del equipo" formControlName="fabricante" (opened)="llenarListaFabricantes()" required>
                              <mat-option *ngFor="let fabricante of listaFabricante" [value]="fabricante.id"> {{ fabricante.name }} </mat-option>
                          </mat-select>
                          <mat-error *ngIf="this.formInsertar.get('fabricante')?.errors?.['required']">
                            El nombre de fabricante es requerido
                        </mat-error>
                      </mat-form-field>
                  </div>
                  <div>
                    <button  mat-mini-fab type="button" style="background-color: #04da44cc;" class="btn btn-primary mx-auto d-block" *ngIf="mostrarBotonesTipoModelo()" (click)="agregarTipoModelo('FABRICANTE')" > <mat-icon>add</mat-icon> </button>
                  </div>
                </div>


            </div>


            <!--Parte 3-->
            <div class="grid-container" >
              <!--Nombre del colaborador encargado del equipo-->
              <div class="celda">
                <mat-label class="label">Nombre del colaborador</mat-label>
                <mat-form-field appearance="outline">
                    <mat-select [formControl]="colaboradorFilter" #singleSelect1  (selectionChange)="cargarDatosEmpleado($event)" >
                    <mat-option>
                        <ngx-mat-select-search [formControl]="inputColaboradorF"  oninput="this.value = this.value.toUpperCase()">
                          <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                          <span ngxMatSelectNoEntriesFound>
                            No se encontraron opciones
                          </span>
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let option of listaFiltradaEmp | async" [value]="option">
                        {{option.nomb_compl}}
                    </mat-option>
                    </mat-select>

                </mat-form-field>
              </div>

              <!--Nombre del puesto-->
              <div class="celda">
                  <mat-label class="label"> Puesto </mat-label>
                  <mat-form-field class="example-form-field" appearance="outline">
                      <input matInput type="text" formControlName="puesto" oninput="this.value = this.value.toUpperCase()"/>
                  </mat-form-field>
              </div>

              <!-- Número de unidades-->
              <div class="celda" *ngIf="activoSeleccionado('RACK')">
                <mat-label class="label"> Número de unidades </mat-label>
                <mat-form-field class="example-form-field" appearance="outline">
                    <input matInput type="number" placeholder="Ingrese el número de unidades" formControlName="numUnidades" min="0" step="1" oninput="this.value = this.value.toUpperCase()"/>
                </mat-form-field>
              </div>
            </div>


            <!--Parte 4-->
            <div class="grid-container">

                <!--Comentarios sobre el equipo-->
                <div class="celda">
                    <mat-label class="label"> Comentarios </mat-label>
                    <mat-form-field class="example-form-field" appearance="outline">
                        <input matInput type="text" formControlName="comentarios" oninput="this.value = this.value.toUpperCase()"/>
                    </mat-form-field>
                </div>
            </div>

        </div>


             <!--Botones-->
      <div class="grid-container2">

        <!--Boton guaradar-->
            <button type="submit" mat-raised-button color="primary"  >GUARDAR       <mat-icon>save</mat-icon>  </button> <!--[disabled]="!habilitarBoton()"-->

        <!--Boton cancelar-->
            <button mat-raised-button color="warn" (click)="goBack()" >CANCELAR</button>
        </div>
    </form>

  </div>

